import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import Banner from './Banner';
import TopCategories from './../components/TopCategories';
import Footer from "./Footer";

export default function Home() {
  useEffect(() => {
    if (!window.gtag) {
      const script1 = document.createElement('script');
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-BFVLCT37PQ'; // Ganti dengan Measurement ID kamu
      script1.async = true;
      document.head.appendChild(script1);

      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;

      gtag('js', new Date());
      gtag('config', 'G-BFVLCT37PQ'); // Ganti dengan Measurement ID kamu
    }
  }, []);

  return (
    <Box sx={{ textAlign: "center", mt: 8 }}>
      <Banner/>
      <Typography variant="h3" gutterBottom>
        Hi, I'm Soesanto 
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph>
        A passionate Full Stack Developer building awesome web applications.
      </Typography>
      <Button variant="contained" size="large" href="/projects">
        See My Projects
      </Button>
      <TopCategories/>
      <Footer/>
    </Box>
  );
}
